"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tooltip = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _core = require("@material-ui/core");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Tooltip = _ref => {
  let {
    title,
    children,
    direction,
    text,
    custom,
    color,
    width,
    referenceIconSize,
    popperIconSize,
    arrow,
    breakpoint,
    modalContent,
    modalClasses,
    openModal,
    onOpenModal,
    onCloseModal
  } = _ref;
  const defaultTooltipClasses = (0, _styles.useDefaultTooltipStyles)();
  const defaultIconButtonClasses = (0, _styles.useDefaultButtonStyles)();
  const customButtonClasses = (0, _styles.useCustomButtonStyles)();
  const customTooltipClasses = (0, _styles.useCustomTooltipStyles)({
    color,
    width
  });
  const popperIconClasses = (0, _styles.usePopperIconStyles)();
  const defaultModalClasses = (0, _styles.useModalStyles)();
  const customModalClasses = modalClasses ? modalClasses() : null;
  const saraivaTheme = (0, _core.useTheme)();
  const isMobile = (0, _core.useMediaQuery)(saraivaTheme.breakpoints.down(breakpoint));
  const [open, setOpen] = (0, _react.useState)(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleToggleOpen = () => {
    setOpen(!open);
  };
  const TooltipLabel = () => {
    const colors = {
      primary: 'primary',
      secondary: 'secondary',
      grey: 'initial'
    };
    return /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "body2",
      component: "span",
      color: custom ? colors[color] : 'initial',
      style: {
        marginRight: saraivaTheme.spacing(0.5)
      }
    }, text);
  };
  const CustomTooltipIconButton = /*#__PURE__*/_react.default.forwardRef(function CustomTooltipIconButton(props, ref) {
    const styles = color === 'grey' ? {
      style: {
        color: saraivaTheme.palette.grey[600]
      }
    } : {
      color
    };
    return /*#__PURE__*/_react.default.createElement(_core.IconButton, _extends({}, props, {
      ref: ref,
      classes: customButtonClasses,
      disableRipple: true
    }), text && /*#__PURE__*/_react.default.createElement(TooltipLabel, {
      text: text
    }), /*#__PURE__*/_react.default.cloneElement(children, {
      ...styles
    }));
  });
  const TooltipWrapper = (0, _core.withStyles)(theme => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 4,
      padding: theme.spacing(1, 2)
    }
  }))(_core.Box);
  const TooltipText = (0, _core.withStyles)(theme => ({
    root: {
      margin: theme.spacing(0, 0, 0, 1.25)
    }
  }))(_core.Typography);
  const TooltipModalPaper = (0, _core.withStyles)(theme => ({
    root: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[5],
      maxWidth: '90%',
      minWidth: 307
    }
  }))(_core.Paper);
  const tooltipModalBody = /*#__PURE__*/_react.default.createElement(TooltipModalPaper, null, modalContent);
  const mobileProps = () => {
    return isMobile ? {
      onClick: custom ? onOpenModal : handleToggleOpen,
      onMouseLeave: handleClose
    } : '';
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Tooltip, _extends({
    placement: direction,
    text: text,
    arrow: arrow,
    title: custom ? /*#__PURE__*/_react.default.createElement(TooltipWrapper, null, /*#__PURE__*/_react.default.cloneElement(children, {
      fontSize: popperIconSize,
      classes: popperIconClasses
    }), /*#__PURE__*/_react.default.createElement(TooltipText, {
      component: "p",
      variant: "body1"
    }, title)) : title,
    classes: custom ? customTooltipClasses : defaultTooltipClasses,
    open: open,
    onClose: handleClose,
    onOpen: handleOpen,
    TransitionProps: {
      timeout: 0
    },
    disableHoverListener: isMobile
  }, mobileProps()), custom ? /*#__PURE__*/_react.default.createElement(CustomTooltipIconButton, {
    size: referenceIconSize
  }) : /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    classes: defaultIconButtonClasses,
    disableRipple: true
  }, text && /*#__PURE__*/_react.default.createElement(TooltipLabel, {
    text: text
  }), children)), /*#__PURE__*/_react.default.createElement(_core.Modal, {
    open: openModal,
    onClose: onCloseModal,
    className: `${defaultModalClasses.modal} ${customModalClasses ? customModalClasses.modal : ''}`
  }, tooltipModalBody));
};
exports.Tooltip = Tooltip;
Tooltip.propTypes = {
  /**
   * O texto da Tooltip
   */
  title: _propTypes.default.string.isRequired,
  /**
   * Elemento de referência da Tooltip
   */
  children: _propTypes.default.node,
  /**
   * Define o posicionamento da Tooltip de acordo com o espaço disponível
   */
  direction: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   * Texto opcional para ser usado como label, ao lado do elemento de referência
   */
  text: _propTypes.default.string,
  /**
   * Habilita/Desabilita a seta de indicação do Tooltip
   */
  arrow: _propTypes.default.bool,
  /**
   * Token do breakpoint que corresponde a quebra do desktop para o mobile.
   */
  breakpoint: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /**
   * Define se a Tooltip será simples ou Customizada
   */
  custom: _propTypes.default.bool,
  /**
   * Cor de destaque do ícone e da Tooltip Customizada
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'grey']),
  /**
   * Tamanho máximo do container da Tooltip Customizada
   */
  width: _propTypes.default.number,
  /**
   * Tamanho do icone de referência da Tooltip Customizada
   */
  referenceIconSize: _propTypes.default.oneOf(['small', 'medium']),
  /**
   * Tamanho do icone exibido na Tooltip Customizada
   */
  popperIconSize: _propTypes.default.oneOf(['small', 'medium']),
  /**
   * Conteúdo interno do modal na Tooltip Customizada mobile
   */
  modalContent: _propTypes.default.node,
  /**
   * Classes para customizar do modal na Tooltip Customizada mobile
   */
  modalClasses: _propTypes.default.func,
  /**
   * Estado que seta abertura/fechamento do modal na Tooltip Customizada mobile
   */
  openModal: _propTypes.default.bool,
  /**
   * Função responsável por fechar o modal na Tooltip Customizada mobile
   */
  onCloseModal: _propTypes.default.func,
  /**
   * Função responsável por abrir o modal na Tooltip Customizada mobile
   */
  onOpenModal: _propTypes.default.func
};
Tooltip.defaultProps = {
  children: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
  direction: 'right',
  text: '',
  custom: false,
  color: 'primary',
  width: 444,
  referenceIconSize: 'small',
  popperIconSize: 'small',
  arrow: false,
  breakpoint: 'sm',
  modalContent: null,
  modalClasses: null,
  openModal: false,
  onCloseModal: () => null,
  onOpenModal: () => null
};
var _default = exports.default = Tooltip;